import React, { useEffect, useRef, useState } from 'react'
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { generalAudioCaching, getSaveData } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import "./mentor-ui.css"
import { VideoSegmentItem, SingleVideoSegmentItem } from '../../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import VideoEnvironment from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';

class MixedMediaUICaching extends VideoSegmentItem {
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'idle',
				src: process.env.PUBLIC_URL + '/assets/videos/mentor/loopVideo.mp4',
				chapterIds: [
				]
			}
		];
	}
}

export const mixedMediaUICaching = new MixedMediaUICaching();

let talkingEnvironment = new VideoEnvironment(null, null);
talkingEnvironment.init();

let playFromState: () => void = null;

let isPaused = false;
let isPlaying = false;
let isLoaded = false;

const MentorUI = (props: MentorUIConfig) => {
	const rootRef = useRef(null);
	const idleRef = useRef(null);
	const saveData = getSaveData();
	isPaused = false;
	isPlaying = false;
	const setIsPlaying = (state: boolean) => {
		const talkingVidParent = rootRef.current.querySelector('.talking-vid');
		if(state) {
			(idleRef.current as HTMLVideoElement).classList.remove('mentor-ui-show-video');
			(idleRef.current as HTMLVideoElement).classList.add('mentor-ui-hide-video');

			talkingVidParent.classList.add('mentor-ui-show-video');
			talkingVidParent.classList.remove('mentor-ui-hide-video');

			(idleRef.current as HTMLVideoElement).pause();

		} else {
			(idleRef.current as HTMLVideoElement).classList.add('mentor-ui-show-video');
			(idleRef.current as HTMLVideoElement).classList.remove('mentor-ui-hide-video');

			talkingVidParent.classList.remove('mentor-ui-show-video');
			talkingVidParent.classList.add('mentor-ui-hide-video');
			(idleRef.current as HTMLVideoElement).play();
		}
	}

	const setIsPaused = (state: boolean) => {
		isPaused = state;
	}

	const setIsLoaded = (state: boolean) => {
		isLoaded = state;
	}

	// const talkingRef = useRef(null);
	if(talkingEnvironment.props && !saveData.isAudioEnabled !== talkingEnvironment.props.muted) {
		talkingEnvironment.props.muted = !saveData.isAudioEnabled;
		(talkingEnvironment.props as any).onForceUpdate();
	}

	setTimeout(() => {
		let obj: any = {
			partId: '',
			url: [props.talkingVideoSrc],
		};
		let envProps = talkingEnvironment.props;
		if(!envProps) {
			envProps = talkingEnvironment.getDefaultProps();
		}
		talkingEnvironment.props = {...talkingEnvironment.props, part: obj, isDirty: true, onPartsLoaded: () => {
			setIsLoaded(true);
			if((window as any)['media-controls-on-video-loaded' + props.mediaId]) {
				(window as any)['media-controls-on-video-loaded' + props.mediaId]();
			}
		}};
		(talkingEnvironment.props as any).onForceUpdate();
	}, 5);

	(window as any)['mentor-ui-update-video-done-playing2' + props.mediaId] = () => {
		setIsPlaying(false)
		talkingEnvironment.pauseCurrentSequence();
		setIsPaused(false)
	}

	(window as any)['mentor-ui-update-video-playing' + props.mediaId] = (state: boolean) => {
		setTimeout(() => {
			setIsPaused(!state);
		}, 0);
		if(!state) {
			talkingEnvironment.pauseCurrentSequence();
			setIsPlaying(state);
			setIsPaused(true);
		} else if(isPaused) {
			setIsPlaying(state);
			talkingEnvironment.resumeCurrentSequence();
		} else {
			setTimeout(() => {
				setIsPlaying(state);
			}, 100);
			
			talkingEnvironment.playSequence({
				sequenceName: 'video',
				props: {
					partId: '',
					chapterId: props.chapterId,
					loop: false
				},
				onDone: () => {
					setIsPlaying(false);
					if((window as any)['mentor-ui-update-video-done-playing' + props.mediaId]) {
						(window as any)['mentor-ui-update-video-done-playing' + props.mediaId]();
					}
				}
			})
		}
	}
	(window as any)['mentor-ui-update-video-skip-back' + props.mediaId] = () => {
		talkingEnvironment.skip(-10);

	}

	(window as any)['mentor-ui-update-video-skip-forward' + props.mediaId] = () => {
		talkingEnvironment.skip(10);
	}


	return (
		<div className='mentor-ui' ref={rootRef}>
			<video autoPlay={true} playsInline muted={!saveData.isAudioEnabled} loop={true} ref={idleRef} className={`mentor-ui-show-video`}>
				<source src={mixedMediaUICaching.getItemByKey('idle').src} type="video/mp4"></source>
			</video>
			<div className='talking-vid mentor-ui-hide-video'>
				{talkingEnvironment.render((memory: string) => {
					}, () => {
					}, null, (videoElementParentId: any, start: number, end: number) => {
						if((window as any)['media-controls-handle-progress' + props.mediaId]) {
							(window as any)['media-controls-handle-progress' + props.mediaId](videoElementParentId, start, end);
						}
					}, () => {
						if((window as any)['mentor-ui-update-video-done-playing' + props.mediaId]) {
							(window as any)['mentor-ui-update-video-done-playing' + props.mediaId]();
						}
					})}
			</div>
			
			{/* <video onTimeUpdate={() => {
				if((window as any)['media-controls-handle-progress' + props.mediaId]) {
					(window as any)['media-controls-handle-progress' + props.mediaId]();
				}
			}} ref={talkingRef} id='mentor-ui-talking-video' className={`mentor-ui-${isPlaying ? "show-video" : "hide-video"}`}>
				<source src="process.env.PUBLIC_URL/assets/videos/mentor/talkVideo.mp4" type="video/mp4"></source>
			</video> */}
		</div>
	);

};

export interface MentorUIConfig extends BaseConfig {
	talkingVideoSrc: string;
	chapterId: string;
	mediaId: string;
}

export default MentorUI;